<template>
	<LayoutSteps class="sticker-form">
		<template slot="steps">
			<AppStep
				v-for="(step, index) in steps"
				:key="step"
				:disabled="index > active"
				@click="active = index"
			>
				{{ `0${index + 1} ${step}`}}
			</AppStep>
		</template>

		<template slot="content">
			<div class="sticker-form__wrapper"  v-if="active === 0">
				<header class="sticker-form__header">Dashboard Emoji</header>
				<AppLoading
					v-if="viewStickersLoading"
				/>
				<div
					class="sticker-form__content sticker-form__content--grid"
					v-if="!viewStickersLoading"
				>
					<div
						class="item"
						v-for="emoji  in viewStickers.emoji"
						:key="emoji.emotion"
					>
						<AppImageUpload
							class="item__file"
							placeholder="Upload"
							v-model="emoji.filepath"
							@error="errorHandler"
							@remove="remove($event)"
						/>

						<div class="item__name">
							{{ emoji.emotion }}
						</div>
					</div>
				</div>

				<div
					class="sticker-form__controls"
					v-if="!viewStickersLoading"
				>
					<AppButton
						modifier="small-primary"
						@click="active = 1"
					>
						Next
					</AppButton>
				</div>
			</div>

			<div class="sticker-form__wrapper" v-if="active === 1">
				<header class="sticker-form__header">Emoji Set</header>

				<div class="sticker-form__content sticker-form__content--grid">
					<div
						class="item"
						v-for="(value, name)  in emojiSet"
						:key="name"
					>
						<AppImageUpload
							class="item__file"
							placeholder="Upload"
							v-model="emojiSet[name]"
							@error="errorHandler"
						/>
						<div class="item__name">
							{{ name }}
						</div>
					</div>
				</div>

				<div class="sticker-form__controls sticker-form__controls">
					<AppButton
						modifier="small-danger"
						@click="active = 0"
					>
						Cancel
					</AppButton>

					<AppButton
						modifier="small-primary"
						@click="active = 2"
					>
						Next
					</AppButton>
				</div>
			</div>

			<div class="sticker-form__wrapper" v-if="active === 2">
				<header class="sticker-form__header">Sticker Set</header>
				<AppImageUpload
					class="multiple-upload"
					:value="viewStickers.sticker.map(i => i.filepath)"
					@input="addStickerSets"
					placeholder="Drag or upload"
					:multiple="true"
					@error="errorHandler"
				/>
				<div class="sticker-form__content sticker-form__content--grid">
					<div
						class="item"
						v-for="(sticker, index)  in viewStickers.sticker"
						:key="index"
					>
						<AppImageUpload
							class="item__file"
							placeholder="Upload"
							:value="sticker.filepath"
							@input="updateStickerSets(index, $event)"
							@remove="viewStickers.sticker.splice(index, 1)"
							@error="errorHandler"
						/>

						<AppTextField
							class="item__name"
							:value="sticker.emotion"
							@input="sticker.emotion = $event"
						/>
					</div>
				</div>

				<div class="sticker-form__controls sticker-form__controls">
					<AppButton
						modifier="small-danger"
						@click="active = 1"
					>
						Cancel
					</AppButton>

					<AppButton
						modifier="small-primary"
						@click="active = 3"
					>
						Next
					</AppButton>
				</div>
			</div>

			<form
				@submit.prevent="save"
				class="sticker-form__wrapper"
				v-if="active === 3"
			>
				<header class="sticker-form__header">Sticker Details</header>
				<div class="sticker-form__content">
					<AppTextField
						class="form-input form-input--text"
						placeholder="Input name"
						v-model="viewDetails.name"
						:required="true"
					>
						Sticker Set Name
					</AppTextField>

					<AppTextField
						class="form-input form-input--text"
						placeholder="Input artist"
						v-model="viewDetails.artist"
						:required="true"
					>
						Artist
					</AppTextField>

					<AppTextarea
						class="form-input"
						placeholder="Input description"
						v-model="viewDetails.description"
						:required="true"
						maxLength="100"
					>
						Sticker Description
					</AppTextarea>

					<AppNumberField
						class="form-input form-input--number"
						placeholder="0"
						v-model="viewDetails.price"
						min="1"
						max="1000"
					>
						Price
					</AppNumberField>
				</div>
				<div class="sticker-form__controls sticker-form__controls">
					<AppButton
						modifier="small-danger"
						@click="active = 2"
					>
						Cancel
					</AppButton>

					<AppButton
						modifier="small-primary"
						type="submit"
						:disabled="buttonLoading"
					>
						Save
					</AppButton>
				</div>
			</form>
		</template>
	</LayoutSteps>
</template>

<script>
import LayoutSteps from '@/components/layouts/LayoutSteps'
import { mapFields } from 'vuex-map-fields'

export default {
	computed: {
		...mapFields('sticker', [
			'viewStickers',
			'viewDetails',
			'viewStickersLoading',
			'buttonLoading'
		]),

		previewStyle () {
			if (this.img.split('.').pop() !== 'png') {
				return `background-image: url(${this.img})`
			}
			return `background-image: url('${this.URL}img/resources/${this.img}')`
		}
	},

	data () {
		return {
			URL: process.env.VUE_APP_BASE,
			steps: [
				'Mood Emoji',
				'Emoji Set',
				'Sticker Set',
				'Sticker Details'
			],

			active: 0,

			moodEmoji: {
				excitement: null,
				pleasant: null,
				happy: null,
				tense: null,
				loading: null,
				calm: null,
				zen: null,
				challenged: null,
				unpleasant: null,
				anxious: null,
				confused: null,
				sad: null
			},

			emojiSet: {
				excitement: null,
				pleasant: null,
				happy: null,
				tense: null,
				loading: null,
				calm: null,
				zen: null,
				challenged: null,
				unpleasant: null,
				anxious: null,
				confused: null,
				sad: null
			},

			stickerSet: []
		}
	},

	methods: {
		remove (e) {
			console.log(e.replace(`${this.URL}img/resources/`, ''))
		},

		errorHandler (msg) {
			alert(msg)
		},

		addStickerSets (files) {
			const addedFiles = Array.from(files).map(file => ({ emotion: '', filepath: file }))
			this.viewStickers.sticker = [...addedFiles, ...this.viewStickers.sticker]
		},

		updateStickerSets (index, newFile) {
			this.viewStickers.sticker.splice(index, 1, { emotion: '', file: newFile })
		},

		async save () {
			const validated = await this.validate()

			if (validated) {
				const sets = ['emoji', 'sticker'] // TODO: add mood here
				const {
					name,
					description,
					artist,
					price
				} = this.viewDetails
				const form = new FormData()

				for (const set of sets) {
					form.append('set_name', name)
					form.append('artist', artist)
					form.append('description', description)
					form.append('price', price)

					this.viewStickers[set].forEach((item, index) => {
						form.append(`${set}[${index}][file]`, item.filepath)
						form.append(`${set}[${index}][emotion]`, item.emotion)
					})
				}

				const api = this.$route.name === 'stickers-update' ? 'sticker/update' : 'sticker/create'
				await this.$store.dispatch(api, { form, router: this.$router })
				return
			}

			this.$store.dispatch('toggleBanner', {
				status: true,
				message: 'Please fill up empty fields!',
				type: 'warning'
			})
		},

		validate () {
			const sets = ['emoji', 'sticker'] // TODO: add mood here

			for (const set of sets) {
				const items = this.viewStickers[set]

				if (items.some(item => item.filepath === null)) {
					return false
				}

				if (set === 'sticker' && items.some(item => item.emotion === '')) {
					return false
				}
			}

			return true
		}
	},

	components: {
		LayoutSteps
	}
}
</script>

<style lang="scss" scoped>
.sticker-form {
	&__wrapper {
		background-color: #fff;
		box-shadow: 0 0 3px $default-light;
		padding: 20px;
		border-radius: 3px;
		width: 400px;
		height: 500px;
		overflow: auto;
		display: flex;
		flex-direction: column;
	}

	.loading {
		margin: auto;
	}

	&__header {
		padding-bottom: 10px;
		margin-bottom: 10px;
		border-bottom: 1px solid #E6EAF2;
	}

	.multiple-upload {
		height: 5em;
		margin-bottom: 10px;
	}

	&__content {
		padding-top: 10px;
		flex: 1 1 auto;
		overflow: auto;

		&--grid {
			display: flex;
			flex-wrap: wrap;
			align-content: flex-start;
			// background-color: red;
		}

		.item {
			flex-basis: 25%;
			margin-bottom: 20px;
			font-size: .8em;
			font-weight: normal;
			text-transform: capitalize;
			display: flex;
			flex-direction: column;
			align-items: center;

			&__file {
				font-size: .8em;
				margin-bottom: 10px;
				border-radius: 50%;
				width: 8em;
				height: 8em;
			}

			&__name {
				padding: 0 10px;
			}
		}

		.form-input {
			width: 100%;
			margin-bottom: 20px;

			&--text {
				width: 45%;

				&:first-child { margin-right: 10%; }
			}

			&--number {
				width: 6em;
			}
		}
	}

	&__controls {
		margin-top: 20px;
		display: flex;
		justify-content: space-between;

		> *:only-child { margin-left: auto; }
	}
}
</style>
